import { COMPONENT_HEIGHTS } from '@amelio/ui-library';

/** Every entry of the plan's lists is one line, at this size. */
export const LIST_FIELD_SIZE = 'md';

/**
 * The lane what sits beside an entry's field — its number, its bin, its label — is placed in: the
 * height of the field, so each stays on the field's line when a refusal is written underneath.
 */
export const LIST_FIELD_LANE = `flex ${COMPONENT_HEIGHTS[LIST_FIELD_SIZE]} items-center`;
